import { atom } from "recoil";

export const modalSearchAwbState = atom({
    key: 'modalSearchAwb',
    default: false
});

export const searchAwbNumState = atom({
    key: 'searchAwbNum',
    default: ''
});

export const searchAwbDataMapState = atom({
    key: 'searchAwbDataMap',
    default: {
        fwb: {
            key: 'fwb',
            name: 'Freight Waybill (FWB)',
            data: [],
            hasData: false,
        },
        fhl: {
            key: 'fhl',
            name: 'Consolidation List (FHL)',
            data: [],
            hasData: false,
        },
        ffm: {
            key: 'ffm',
            name: 'Flight Manifest (FFM)',
            data: [],
            hasData: false,
            dataCount: 0,
        },
        locations: {
            key: 'locations',
            name: 'Warehouse Locations',
            data: [],
            hasData: false,
        },
        notifications: {
            key: 'notifications',
            name: 'Shipment Notification (NFD)',
            data: [],
            hasData: false,
        },
        payments: {
            key: 'payments',
            name: 'Cargo Payment',
            data: [],
            hasData: false,
        },
        import: {
            key: 'import',
            name: 'Delivery Process',
            data: [],
            hasData: false,
        },
        export: {
            key: 'export',
            name: 'Acceptance Process',
            data: [],
            hasData: false,
        },
        fsn: {
            key: 'fsn',
            name: 'Freight Status Notification (FSN)',
            data: [],
            hasData: false,
        },
        warehouse: {
            key: 'warehouse',
            name: 'Warehouse Check In',
            data: [],
            hasData: false,
        },
        dlv: {
            key: 'dlv',
            name: 'Freight Status Delivered (DLV)',
            data: [],
            hasData: false,
        },
        cdr: {
            key: 'cdr',
            name: 'Cargo Damage Report',
            data: [],
            hasData: false,
        },
        log: {
            key: 'log',
            name: 'Log/Notes',
            data: [],
            hasData: false,
        },
        visualReporting: {
            key: 'visualReporting',
            name: 'Visual Reporting',
            data: [],
            hasData: false,
        },
    }
});

export const additionalSearchAwbDataState = atom({
    key: 'additionalSearchAwbData',
    default: null
});

export const loadingState = atom({
    key: 'loading',
    default: false
});